// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import {ssoUserActivateUserAction} from "../../actions/sso/creators/ssoUserActionCreator";
import * as _ from 'lodash';
import type {ActivateUserModalDispatchProps, ActivateUserModalStateProps} from "../../components/sso/ActivateUserModal";
import ActivateUserModal from "../../components/sso/ActivateUserModal";
import {closeSsoUserActivateUserModalAction} from "../../actions/modal/creators/ssoUserActivateUserActionCreator";
import type {Caller} from "../../components/QueryPage";
import {extractCaller} from "../QueryPage";
import SsoUser from "../../model/sso/SsoUser";

const mapStateToProps = (state: StoreState): ActivateUserModalStateProps => {

    const isLoading = state.modal.activateUser.ssoUid
        ? _.get(state, `ssoUserAction.activateUser.${state.modal.activateUser.ssoUid}.isLoading`, false)
        : false;

    let user: SsoUser = _.find(state.ssoUserQuery.ssoUsers, ['ssoUid', +state.modal.activateUser.ssoUid]);

    const error = state.modal.activateUser.ssoUid
        ? _.get(state, `ssoUserAction.activateUser.${state.modal.activateUser.ssoUid}.error`)
        : undefined;

    return {
        open: state.modal.activateUser.open,
        ssoUid: state.modal.activateUser.ssoUid,
        email: _.get(user, 'email'),
        caller: extractCaller(state),
        isLoading,
        error
    };
};

const mapDispatchToProps = (dispatch): ActivateUserModalDispatchProps => {
    return {
        closeModal: () => {
            dispatch(closeSsoUserActivateUserModalAction());
        },
        activateUser: (ssoUid: string, caller: Caller) => {
            dispatch(ssoUserActivateUserAction(ssoUid, caller));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivateUserModal);



// WEBPACK FOOTER //
// ./src/containers/sso/ActivateUserModal.js